import mediator from "@tvg/mediator";
import { get } from "lodash";
import { BaseEventProps, track } from "@tvg/amplitude";
import { MediatorEventType, EventProps, PreferencesData } from "./types";
import { EVENT_NAME } from "./constants";

export default () => {
  mediator.base.subscribe(
    MediatorEventType.UNSUB_CLICK,
    (data: PreferencesData) => {
      track<EventProps>(EVENT_NAME.UNSUB_CLICK, {
        [BaseEventProps.EVENT_CATEGORY]: "Preferences",
        [BaseEventProps.EVENT_LABEL]: get(data, "payload.gaEventLabel", ""),
        [BaseEventProps.MODULE]: "Email Unsubscribe"
      });
    }
  );

  mediator.base.subscribe(MediatorEventType.UNSUB_SUCCESS, () => {
    track<EventProps>(EVENT_NAME.UNSUB_SUCCESS, {
      [BaseEventProps.EVENT_CATEGORY]: "Unsubscribe Success",
      [BaseEventProps.MODULE]: "Email Unsubscribe"
    });
  });

  mediator.base.subscribe(MediatorEventType.UNSUB_FAIL, () => {
    track<EventProps>(EVENT_NAME.UNSUB_FAIL, {
      [BaseEventProps.EVENT_CATEGORY]: "Preferences",
      [BaseEventProps.EVENT_LABEL]: "Missing required url parameter",
      [BaseEventProps.MODULE]: "Email Unsubscribe"
    });
  });

  mediator.base.subscribe(
    MediatorEventType.SUB_CLICK,
    (data: PreferencesData) => {
      track<EventProps>(EVENT_NAME.SUB_CLICK, {
        [BaseEventProps.EVENT_CATEGORY]: "Preferences",
        [BaseEventProps.EVENT_LABEL]: get(data, "payload.gaEventLabel", ""),
        [BaseEventProps.MODULE]: "Communication Preferences"
      });
    }
  );

  mediator.base.subscribe(MediatorEventType.SUB_SUCCESS, () => {
    track<EventProps>(EVENT_NAME.SUB_SUCCESS, {
      [BaseEventProps.EVENT_CATEGORY]: "Preferences",
      [BaseEventProps.MODULE]: "Communication Preferences"
    });
  });

  mediator.base.subscribe(
    MediatorEventType.SUB_FAIL,
    (data: PreferencesData) => {
      track<EventProps>(EVENT_NAME.SUB_FAIL, {
        [BaseEventProps.EVENT_CATEGORY]: "Preferences",
        [BaseEventProps.EVENT_LABEL]: get(data, "payload.gaEventLabel", ""),
        [BaseEventProps.MODULE]: "Communication Preferences"
      });
    }
  );
};
